import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Newspaper, FileText, Image, Calendar, MessageSquare, Inbox } from "lucide-react";

const cards = [
  { k: "berita", label: "Berita", icon: Newspaper, color: "#005F8E" },
  { k: "regulasi", label: "Regulasi", icon: FileText, color: "#0086C6" },
  { k: "galeri", label: "Galeri", icon: Image, color: "#00B4D8" },
  { k: "agenda", label: "Agenda", icon: Calendar, color: "#48CAE4" },
  { k: "kontak_total", label: "Total Pesan", icon: MessageSquare, color: "#003A5C" },
  { k: "kontak_baru", label: "Pesan Baru", icon: Inbox, color: "#F39C12" },
];

export default function AdminDashboard() {
  const [d, setD] = useState({});
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)); }, []);
  return (
    <div>
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">Dashboard</div>
        <h1 className="font-heading font-bold text-3xl text-[#003A5C]">Ringkasan Portal</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
        {cards.map((c) => (
          <div key={c.k} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
            <div className="w-12 h-12 rounded-full grid place-items-center mb-3" style={{ background: `${c.color}20`, color: c.color }}>
              <c.icon className="w-6 h-6" />
            </div>
            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{c.label}</div>
            <div className="font-heading font-bold text-3xl text-[#003A5C] mt-1">{d[c.k] ?? "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
